import { render, staticRenderFns } from "./rapprochement.vue?vue&type=template&id=564625e2&scoped=true"
import script from "./rapprochement.vue?vue&type=script&lang=js"
export * from "./rapprochement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564625e2",
  null
  
)

export default component.exports